import { render, staticRenderFns } from "./AttributeFilter.vue?vue&type=template&id=222dcea6"
import script from "./AttributeFilter.vue?vue&type=script&lang=js"
export * from "./AttributeFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports